import { Component, ElementRef, computed, inject, input, viewChild } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AvailableBoardsDialogComponent } from './available-boards-dialog/available-boards-dialog.component';
import { PipesModule } from '@/modules/shared/pipes/pipes.module';
import { OfferList } from '@/_store/offers/offers.types';
import { MainService } from '@/main/services/main.service';
import { TransportKind } from '@/offer/offer.model';
import { LocationKind } from '@/_store/current-offer/current-offer.types';
import { OffersFacade } from '@/_store/offers/offers.facade';

@Component({
	selector: 'app-offer-box',
	templateUrl: './offer-box.component.html',
	styleUrls: ['./offer-box.component.scss'],
	standalone: true,
	imports: [CommonModule, NgOptimizedImage, PipesModule],
})
export class OfferBoxComponent {
	readonly offer = input.required<OfferList>();

	readonly TransportKind = TransportKind;

	readonly locations = computed(() => {
		const countryLocations = this.offer().locations.filter((location) => location.kind === LocationKind.COUNTRY);

		if (countryLocations.length === 0) {
			return this.offer().locations.length ? this.offer().locations[0].name : '';
		}

		return countryLocations
			.reduce((acc, location) => {
				acc += `${location.name}, `;
				return acc;
			}, '')
			.slice(0, -2);
	});

	readonly mainService = inject(MainService);
	readonly offersFacade = inject(OffersFacade);

	private readonly boardsTooltip = viewChild<ElementRef<HTMLElement>>('boardsTooltip');

	private readonly dialog = inject(MatDialog);

	displayMoreFoodInfo(item: OfferList): void {
		const iconPosition = this.boardsTooltip().nativeElement.getBoundingClientRect();

		this.dialog.open(AvailableBoardsDialogComponent, {
			hasBackdrop: false,
			position: {
				top: `${iconPosition.y}px`,
				left: `${iconPosition.x}px`,
			},
			data: {
				productId: item.product.id,
			},
		});
	}
}
